import styled from "styled-components";
import { Button } from "@mui/material";

export const Container = styled.div`
  width: 100%;
  height: 100vh;
  .css-1nxtzl-MuiGrid-root > .MuiGrid-item {
    padding-top: 0;
  }
`;

export const Content = styled.div`
  width: 100%;
  padding: 33px 16px;
`;

export const ContainerContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const ActionContainer = styled(Button)`
  display: flex;
  align-items: center;
  transition: opacity 0.2s !important;

  &:hover {
    opacity: ${({ theme }) => theme.palette.action.hoverOpacity};
    background-color: transparent !important;
  }
`;
